import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    nivelConsumoAlcohol: [],
  },

  getters: {
    getNivelConsumoAlcohol: (state) => state.nivelConsumoAlcohol,
  },

  mutations: {
    SET_NIVEL_CONSUMO_ALCOHOL(state, nivelConsumoAlcohol) {
      state.nivelConsumoAlcohol = nivelConsumoAlcohol;
    },
  },

  actions: {
    async fetchNivelConsumoAlcohol({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/CatNivelConsumoAlcohol')
        .then((response) => {
          commit('SET_NIVEL_CONSUMO_ALCOHOL', response.data.data);
        });
    },
  },
};
